/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import Flex from 'atoms/Flex'
/* ------------------------- Internal Dependencies -------------------------- */
import MenuIconsComplex from 'components/layout/MenuIconsComplex'
/* ------------------------------- Component -------------------------------- */
export default props => 
<div>
  <Flex direction='column' w={[1]} >
    <MenuIconsComplex owner="aside" />
  </Flex>
</div>


// WEBPACK FOOTER //
// ./src/interface/components/zones/AsideSmall/index.js